import React from 'react';

const FONT_STACK = "'Poppins', 'Segoe UI', system-ui, -apple-system, sans-serif";

const SocialMedia = () => {
  const redes = [
    {
      id: 1,
      nombre: 'Instagram',
      // Optimizado a 100px para que se vea nítido en 40px reales
      imagen: 'https://res.cloudinary.com/dbhpessue/image/upload/w_100,f_auto,q_auto/v1783019407/images_ucplqw.png',
      enlace: 'https://www.instagram.com/horeblife?igsh=c2JsYnZ0dnN2azdw',
    },
    {
      id: 2,
      nombre: 'TikTok',
      imagen: 'https://res.cloudinary.com/dbhpessue/image/upload/w_100,f_auto,q_auto/v1783019407/tiktok_taebty.png',
      enlace: 'https://www.tiktok.com/@horeblife?_r=1&_t=ZS-978fD1qYzDh',
    },
    {
      id: 3,
      nombre: 'Facebook',
      imagen: 'https://res.cloudinary.com/dbhpessue/image/upload/w_100,f_auto,q_auto/v1783019407/facebook_uazgfz.png',
      enlace: 'https://www.facebook.com/profile.php?id=61590481857428',
    },
  ];

  return (
    <footer style={{
      backgroundColor: '#fcfcfc', 
      padding: '35px 20px',
      borderTop: '1px solid #eee',
      marginTop: '40px',
      textAlign: 'center',
      fontFamily: FONT_STACK
    }}>
      <div style={{ maxWidth: '400px', margin: '0 auto' }}>
        
        <p style={{
          fontSize: '0.9rem',
          color: '#444',
          marginBottom: '20px',
          fontWeight: 600,
          letterSpacing: '0.3px'
        }}>
          Síguenos en nuestras redes
        </p>
        
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '30px', // Más espacio entre iconos para evitar toques accidentales
          marginBottom: '25px'
        }}>
          {redes.map((red) => (
            <a
              key={red.id}
              href={red.enlace}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'block',
                transition: 'transform 0.2s ease-in-out',
                WebkitTapHighlightColor: 'transparent' // Evita el cuadro azul al tocar en celular
              }}
              // Efecto visual al tocar/hacer hover
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <img
                src={red.imagen}
                alt={red.nombre}
                style={{
                  width: '40px',  // Tamaño "Goldilocks": ni muy grande ni muy pequeño
                  height: '40px',
                  objectFit: 'contain'
                }}
              />
            </a>
          ))}
        </div>
        
        <div style={{
          fontSize: '0.75rem',
          color: '#aaa',
          letterSpacing: '0.5px'
        }}>
          © {new Date().getFullYear()} HOREB LIFE
        </div>
      </div>
    </footer>
  );
};

export default SocialMedia;